import { render, staticRenderFns } from "./ManagePrices.vue?vue&type=template&id=42ead253&"
import script from "./ManagePrices.vue?vue&type=script&lang=js&"
export * from "./ManagePrices.vue?vue&type=script&lang=js&"
import style0 from "./ManagePrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports